import React from "react";
import ct from "class-types.macro";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import { VariantProps } from ".";
import UnitOfMeasure from "../../UnitOfMeasure";
import Registered from "./Registered";

const J = ({
  user,
  selectedProduct,
  productListingView,
  setIsQuantityDiscountPopoverOpen,
}: VariantProps) => {
  const regularUserQualifiedForMapPricing =
    user.registered &&
    !(user.hasWebPlus || user.platinum.enabled) &&
    user.amountSpentOneThousandOrMore &&
    selectedProduct.showBelowMinimumAdvertisedPriceForLoggedInCustomers;

  const platPlusUserQualifiedForMapPricing =
    (user.hasWebPlus || user.platinum.enabled) &&
    (selectedProduct.showBelowMinimumAdvertisedPriceForLoggedInCustomers ||
      selectedProduct.showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers);

  return regularUserQualifiedForMapPricing ||
    platPlusUserQualifiedForMapPricing ? (
    <Registered
      {...{
        user,
        selectedProduct,
        setIsQuantityDiscountPopoverOpen,
      }}
    />
  ) : (
    <div className="map map-override mapJ">
      <p
        className={`price ${ct(
          "font-semibold",
          "text-2xl",
          "leading-none",
          "mb-0",
          "relative",
          "text-red-500",
          "z-5",
        )}`}
      >
        {formatAsCurrency.formatIfUndefined(selectedProduct.price.price)}
        <UnitOfMeasure unitOfMeasure={selectedProduct.unitOfMeasure} />
      </p>
      <p
        className={ct(
          "font-semibold",
          "text-xs",
          "leading-none",
          "mb-0",
          "text-gray-800",
          productListingView === "list"
            ? ct("xs:text-center")
            : ct("text-center"),
        )}
      >
        Contact us for details
      </p>
      <p
        className={ct(
          "font-semibold",
          "text-xs",
          "leading-snug",
          "mb-2",
          productListingView === "list"
            ? ct("xs:text-center")
            : ct("text-center"),
        )}
      >
        Call 717-392-7472
      </p>
    </div>
  );
};

export default J;
